var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createBasicCrypto, HASH_SHA256 } from "@hyper-hyper-space/hhs3_crypto";
import { MemDagBackend, Replica as ReplicaClass } from "@hyper-hyper-space/hhs3_replica";
import { payloadName, rehydrateRoots } from "./rehydrate.js";
import { registerRdbTypes } from "./register_types.js";
import { RootIndex } from "./root_index.js";
export class RdbWorkspace {
    constructor(backendLabel, replica, backend, roots) {
        this.backendLabel = backendLabel;
        this.replica = replica;
        this.backend = backend;
        this.roots = roots;
    }
    static open(options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            const crypto = (_a = options.crypto) !== null && _a !== void 0 ? _a : createBasicCrypto();
            const hashSuite = (_b = options.hashSuite) !== null && _b !== void 0 ? _b : crypto.hash(HASH_SHA256);
            const backendLabel = (_c = options.backendLabel) !== null && _c !== void 0 ? _c : 'default';
            const replica = new ReplicaClass({
                crypto,
                hashSuite,
                config: (_d = options.replicaConfig) !== null && _d !== void 0 ? _d : { selfValidate: true },
            });
            replica.attachBackend(backendLabel, options.backend);
            registerRdbTypes(replica);
            const roots = (_e = options.roots) !== null && _e !== void 0 ? _e : new RootIndex();
            const workspace = new RdbWorkspace(backendLabel, replica, options.backend, roots);
            if (options.rehydrate !== false) {
                yield rehydrateRoots(replica, options.backend, roots);
            }
            return workspace;
        });
    }
    createRoot(plan) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const object = yield this.replica.createObject(plan.payload, this.backendLabel);
            this.roots.registerObject(object.getId(), object, (_a = plan.name) !== null && _a !== void 0 ? _a : payloadName(plan.payload));
            return object;
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.replica.destroy();
            const closeable = this.backend;
            if (closeable.close !== undefined) {
                yield closeable.close();
            }
        });
    }
}
export function openMemWorkspace(opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const crypto = createBasicCrypto();
        const hashSuite = crypto.hash(HASH_SHA256);
        const backend = new MemDagBackend(hashSuite);
        return RdbWorkspace.open({
            backend,
            crypto,
            hashSuite,
            backendLabel: opts === null || opts === void 0 ? void 0 : opts.backendLabel,
            replicaConfig: opts === null || opts === void 0 ? void 0 : opts.replicaConfig,
            rehydrate: opts === null || opts === void 0 ? void 0 : opts.rehydrate,
        });
    });
}
